import { Component, OnInit,Input, Output,EventEmitter } from '@angular/core';

@Component({
  selector: 'app-gestiones-buroexterno',
  templateUrl: './gestiones-buroexterno.component.html',
  styleUrls: ['./gestiones-buroexterno.component.scss']
})
export class GestionesBuroexternoComponent implements OnInit {
  @Output() selecttab = new EventEmitter<number>();
  @Output() selectParticipante = new EventEmitter<number>();
  @Input() gestionSeleccionada: any;
  @Input() participante: any;
  listvigentesycancelados = [];
  constructor() {
    setTimeout(() => {
      if (this.gestionSeleccionada.participante[this.participante].sircRuta15.mensaje !== null) {
        this.gestionSeleccionada.participante[this.participante].sircRuta15.mensaje.contenido.endeudaVigentes.forEach(element => {
          element.estado = 'vigente';
          this.listvigentesycancelados.push(element);
        });
        this.gestionSeleccionada.participante[this.participante].sircRuta15.mensaje.contenido.endeudaCancelados.forEach(element => {
          element.estado = 'cancelado';
          this.listvigentesycancelados.push(element);
        });
      }
  }, 500);
  }

  ngOnInit(): void {
  }
  selectedtab(tab) {
    this.selecttab.emit(tab);
  }
  selectedparticipante(item) {
    this.selectParticipante.emit(item);
  }
  setFormatDate(date: string) {
    let dia = date.substring(0, 2);
    let mes = date.substring(2, 4);
    let ano = date.substring(4);
    return dia+'/'+mes+'/'+ano;
  }
}
